import { reportErrorToFaro } from '@sendible/common';
import AccountModel from '../../models/account/AccountModel.js';
import EmojiPickerView from '../compose/EmojiPickerView.js';
import SocialProfileCollection from '../../collections/manage/SocialProfileCollection.js';
import htmlEditorTemplate from '../../../templates/common/htmlEditorTemplate.html';
import composeNotificationTemplate from '../../../templates/compose/composeNotificationTemplate.html';

const START_KEYCODE = 48;
const END_KEYCODE = 111;

const MIN_QUERY_LENGTH = 2;
const LINKEDIN_MIN_QUERY_LENGTH = 3;

const HTMLBox = Backbone.View.extend({
  id: 'html-box',
  className: 'modal modal-bigger hide fade',
  template: _.template(htmlEditorTemplate),

  events: {
    'click .btn-success': 'updateHTML',
    'click .auto-format': 'autoFormat',
    'click .close': 'close',
  },

  initialize() {
    this.$el.html(this.template({ content: this.options.content }));
  },

  render() {
    const that = this;

    this.$el.on('hidden', _.bind(this.cleanup, this));
    this.$el.modal({ backdrop: 'static', keyboard: false });

    this.$el.one('shown', () => {
      // eslint-disable-next-line import/no-unresolved
      import('../../libs/codemirror/codemirror-compressed.js').then(() => {
        that.editor = CodeMirror.fromTextArea(that.$('#markupEditor')[0], {
          lineNumbers: true,
          lineWrapping: true,
          mode: 'text/html',
        });
        that.editor.refresh();
        that.autoFormat();
      });

      that.$('#markupEditor').focus();
    });
  },

  updateHTML() {
    let richText = this.editor.getValue();
    // remove script and style tags
    richText = richText.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
    this.$('#markupEditor').val(richText);
    this.options.onUpdate(this.$('#markupEditor').val());
    this.close();
  },

  getSelectedRange() {
    return { from: this.editor.getCursor(true), to: this.editor.getCursor(false) };
  },

  autoFormat() {
    CodeMirror.commands.selectAll(this.editor);
    const range = this.getSelectedRange();
    this.editor.autoFormatRange(range.from, range.to);
  },

  close() {
    this.$el.modal('hide');
  },

  cleanup() {
    this.unbind();
    this.remove();
  },

});

const RTEView = Backbone.View.extend({
  className: 'editor-view',
  mode: 'plain',
  contentBodyExtractionRegex: /<body>([\s\S]+)<\/body>/gmi,
  anchorTagMatchEndOfBodyRegex: /<a(.)+class=["'](twitter|facebook|linkedin)-tag-it["'](.)+>(.)+<\/a>$/gmi,
  tagMatchEndOfBodyRegex: /@(\w)+$/gmi,

  initialize() {
    const self = this;
    let $selector;
    let pathName;
    let domain_url = `${location.protocol}//${location.hostname}`;

    if (location.port && location.port != '' && location.port != '8000') {
      domain_url = `${location.protocol}//${location.hostname}:${location.port}`;
    }

    // initialise messageStat object
    this.messageState = {
      msgText: null,
      msgRichText: null,
      msgTextLength: null,
      arTextLinks: [],
      arShortenedLinks: [],
      arHrefLinks: [],
      hasInlineMedia: false,
      arIncompleteLinks: [],
      hasTwitterHashtag: false,
      hasInstagramHashtag: false,
      noOfEmojis: 0,
      lastKeypressCode: null,
      hasContentChanged: false,
      $domBody: null,
      changeType: null, // [paste, keyup, textInserted]
      selector: this.options.selector,
    };

    // prepare config defaults
    this.options.onUserTyped = this.options.onUserTyped || function () {};
    this.options.onMentionInserted = this.options.onMentionInserted || function () {};
    this.options.onEditorInitialised = this.options.onEditorInitialised || function () {};
    this.options.onBeforeShortenLinks = this.options.onBeforeShortenLinks || function () {};
    this.options.onAfterShortenLinks = this.options.onAfterShortenLinks || function () {};
    this.options.onEditorBlur = this.options.onEditorBlur || function () {};

    this.options.noShortenLinks = this.options.noShortenLinks || false;
    this.options.$emojiPickerTrigger = this.options.$emojiPickerTrigger || null;
    this.options.maxEditorHeight = self.options.maxEditorHeight || 300;
    this.options.initialEditorHeight = self.options.initialEditorHeight || 200;
    this.options.parent = this.options.parent || null;
    this.options.$igFirstCommentField = this.options.$igFirstCommentField || null;

    this.options.guid = Utils.guid();

    if (this.options.enableNotifications) {
      $selector = $(`#${this.options.selector}`).parent();

      this.$notifySection = $selector.find('.notify-section');
      this.$counterSection = $selector.find('.compose-counter');
      this.$attachmentSection = $selector.find('.compose-attachments-list');

      this.notifyTemplate = _.template(composeNotificationTemplate);
      this.$tab = $(`.text-area-holder .tab-area-holder .tab-${this.options.selector}`);
    }

    this.debounced_updateEditorHeight = _.debounce(this.updateEditorHeight, 700);

    this.debounced_displayMentionsFor_facebook = _.debounce(this.displayMentionsFor_facebook, 500);

    this.debounced_displayMentionsFor_twitter = _.debounce(this.displayMentionsFor_twitter, 500);

    this.debounced_displayMentionsFor_threads = _.debounce(this.displayMentionsFor_threads, 500);

    this.debounced_displayMentionsFor_bluesky = _.debounce(this.displayMentionsFor_bluesky, 500);

    this.debounced_displayMentionsFor_linkedin = _.debounce(this.displayMentionsFor_linkedin, 500);

    // defaults
    this.mode = 'plain';
    this.isMaximised = false;
    this.currentMinHeight = '70px';
    this.isCustomised = false;
    this.arClosedNotifications = [];
    this.hasInlineMedia = false;
    this.isModalOpening = false;

    this.serviceIcons = {
      twitter: '<i class="icon-twitter-sign"></i> &nbsp;',
      facebook: '<i class="icon-facebook-sign"></i> &nbsp;',
      linkedin: '<i class="icon-linkedin-sign"></i> &nbsp;',
      instagram: '<i class="icon-instagram"></i> &nbsp;',
      threads: '<i class="icon-threads-sign"></i> &nbsp;',
      bluesky: '<i class="icon-bluesky"></i> &nbsp;',
    };

    // setup domain path to retrieve css files
    if (location.pathname && location.pathname.length && location.pathname.indexOf('concise') != -1) {
      this.domainPath = domain_url + location.pathname.substr(0, location.pathname.indexOf('/concise'));
    } else if (location.pathname && location.pathname.length && location.pathname !== '/') {
      pathName = location.pathname;
      pathName = pathName.charAt(pathName.length - 1) == '/' ? pathName.substr(0, pathName.length - 1) : pathName;
      this.domainPath = domain_url + pathName;
    } else {
      this.domainPath = domain_url;
    }

    // if mode explicitly set in configuration then set it
    if (typeof this.options.mode !== 'undefined' && this.options.mode == 'rich') {
      this.mode = 'rich';
      window.globalObject.composeIsRichMode = true;
    } else if (typeof this.options.mode !== 'undefined' && this.options.mode == 'plain') {
      this.mode = 'plain';
    } else if ($current_user.preference == 'rte_on') {
      this.mode = 'rich';
      window.globalObject.composeIsRichMode = true;
    } else if ($current_user.preference == 'rte_off') {
      this.mode = 'plain';
    }

    this.currentMentionDelimeter = '';
    this.mentionFetching = false;

    this.isCTRLPressed = false;

    this.socialProfiles = new SocialProfileCollection() || this.socialProfiles;

    this.setupTinyMceEditor();

    this.setupEmojiPicker();

    if (this.options.$igFirstCommentField) {
      this.options.$igFirstCommentField.on('keyup', this.onKeyUp.bind(this));
    }

    this.emojiList = this.prepopulateEmojiList();
  },

  setupTinyMceEditor() {
    const self = this;

    if (!window.tinymce) {
      this.reloadTinyMCE(() => {
        self.setupTinyMceEditor();
      });
    }

    window.tinymce.init({
      setup(editor) {
        self.tmceEditor = editor;

        // Add custom buttons
        editor.addButton('htmlButton', {
          icon: 'code',
          tooltip: 'HTML Mode',
          onclick() {
            self.openHtml();
          },
        });

        // bind to tinymce editor events
        editor.on('init', () => {
          self.container = editor.getContainer();
          self.editor_ifr = self.container.querySelector('iframe');

          const twitterActive = self.options.selector === 'compose-twitter'
                            || self.options.selector === 'compose-message';

          self.tmceEditor.socialMediaState = {
            twitterActive,
          };

          self.editor_ifr.setAttribute('title', '');
          self.editor_ifr.style.overflow = 'hidden';

          self.container.setAttribute('data-gramm', 'false');
          self.editor_ifr.setAttribute('data-gramm', 'false');

          self.messageState.$domBody = $(self.tmceEditor.getBody());

          self.messageState.$domBody.addClass(`${self.options.selector}-editor`);

          self.messageState.$domBody.delegate('a[data-mce-href]', 'click', _.bind(self.handleTagClick, self));

          setTimeout(_.bind(function () {
            if (this.mode == 'plain') {
              this.setEditorModetoPlain();
              this.editor_ifr.style.height = this.currentMinHeight;
            } else {
              this.editor_ifr.style.height = `${this.options.initialEditorHeight}px`;
            }

            if (this.isMaximised) {
              this.maximizeEditor();
            }
          }, self), 100);

          self.updateEditor();

          self.checkEmojis();
          // Change font size icon
          $('.mce-fixed-width button').html('<i class="mce-ico mce-i-fontsize"></i><i class="mce-ico mce-i-custom-caret"></i>');

          $('.mce-fixed-width').css('width', '33px');

          setTimeout(_.bind(function () {
            this.options.onEditorInitialised();

            this.messageState.$domBody.find('.emoji').attr('data-mce-resize', 'false');
          }, self), 0);

          self.setFocus();
        });

        editor.on('change', () => {
          self.updateMessageStateLinks();
        });

        editor.on('blur', () => {
          self.options.onEditorBlur();
        });

        editor.on('paste', _.bind(() => {
          setTimeout(() => {
            self.onPasted();
          }, 100);
        }, self));

        editor.on('keydown', _.bind(self.handleKeyDown, self));

        editor.on('keyup', _.bind(self.onKeyUp, self));

        editor.on('click', _.bind(self.handleEditorClicked, self));
      },
      selector: `#${self.options.selector}`,
      resize: false,
      valid_elements: '@[id|class|data-gram|title|style|data-options|data*],'
+ 'a[name|href|target|title],'
+ 'iframe[src|style|width|height|scrolling|marginwidth|marginheight|frameborder|allowfullscreen|encrypted|allow],'
+ '#p,-ol,-ul,-li,br,img[src|height|width],-b,-i,-u,'
+ '-span[data-mce-type],hr,strong,em',
      valid_styles: { '*': '*', span: 'background,color,background-color,text-decoration,font-size' },
      invalid_elements: '@[data-mce-type]',
      autoresize_min_height: self.currentMinHeight,
      autoresize_bottom_margin: 20,
      autoresize_on_init: false,
      auto_focus: self.options.selector,
      content_css: `${self.domainPath}/libs/tinymce/default.css`,
      skin_url: '/libs/tinymce/skins/social-media',
      forced_root_block: false,
      statusbar: false,
      menubar: false,
      plugins: [
        'mention advlist lists link image anchor visualblocks fullpage media table paste textcolor',
      ],
      entity_encoding: 'raw',
      fontsize_formats: '8pt 10pt 12pt 14pt 18pt',
      browser_spellcheck: true,
      toolbar: 'fontsizeselect bold italic strikethrough underline bullist numlist outdent indent alignleft aligncenter alignright alignjustify forecolor backcolor link undo redo htmlButton',
      height: self.currentMinHeight,
      mentions: {
        delimiter: ['@', ':'],
        delay: 200,
        items: 11,
        queryBy: 'username',
        source(query, process, delimiter) {
          let loadingIcon = self.serviceIcons.facebook;
          let startTypingText = window.lookup('Start typing to filter the results');
          let minQueryLength = MIN_QUERY_LENGTH;

          if (!self.mentionTaggingFor) {
            self.mentionTaggingFor = 'facebook';
          }

          if (self.mentionTaggingFor === 'linkedin') {
            minQueryLength = LINKEDIN_MIN_QUERY_LENGTH;
          }

          self.currentMentionDelimeter = delimiter;

          // if there is a space in the query then ignore
          if (!self.mentionFetching && query.length == 0) {
            // show loading window
            // data, showLoading, strDropDownMessage, type
            if (self.serviceIcons[self.mentionTaggingFor]) {
              loadingIcon = self.serviceIcons[self.mentionTaggingFor];
            }

            if ((
              self.mentionTaggingFor === 'instagram'
              || self.mentionTaggingFor === 'twitter'
              || self.mentionTaggingFor === 'threads'
              || self.mentionTaggingFor === 'bluesky') && delimiter == '@') {
              startTypingText = window.lookup('Start typing');
            }

            process(null, true, loadingIcon + startTypingText, self.mentionTaggingFor);
          }
          if (
            (delimiter == '@' && self.mentionFetching)
                        || (delimiter == '@' && query.length < minQueryLength)) {
            return;
          }

          if (delimiter == ':') {
            self.displayMentionsFor_Emojis(query, process);
            return;
          }

          if (delimiter == '@') {
            self.mentionFetching = false;

            if (self.mentionTaggingFor === 'twitter') {
              self.debounced_displayMentionsFor_twitter(query, process, self.mentionTaggingFor_accountID);
            } else if (self.mentionTaggingFor === 'threads') {
              self.debounced_displayMentionsFor_threads(query, process, self.mentionTaggingFor_accountID);
            } else if (self.mentionTaggingFor === 'bluesky') {
              self.debounced_displayMentionsFor_bluesky(query, process, self.mentionTaggingFor_accountID);
            } else if (self.mentionTaggingFor === 'instagram') {
              self.displayMentionsFor_instagram(query, process);
            } else if (self.mentionTaggingFor === 'linkedin') {
              self.debounced_displayMentionsFor_linkedin(query, process, self.mentionTaggingFor_accountID);
            } else if (self.mentionTaggingFor === 'facebook') {
              self.debounced_displayMentionsFor_facebook(query, process, self.mentionTaggingFor_accountID);
            } else {
              self.debounced_displayMentionsFor_facebook(query, process, self.mentionTaggingFor_accountID);
            }
          }
        },
        matcher() {
          return true;
        },
        render(item, index) {
          let liItem = `<li data-value="${item.username}"${
            (self.mentionTaggingFor === 'linkedin'
            || self.mentionTaggingFor === 'instagram'
            || self.mentionTaggingFor === 'threads'
            || self.mentionTaggingFor === 'bluesky'
            || self.mentionTaggingFor === 'twitter')
            && index == 0 ? ' class="active" >' : ' >'
          }<a href="javascript:;">`;

          if (self.currentMentionDelimeter === ':' && item.image) {
            liItem += `<div class="mention_image">${item.image}</div>`;
          } else if (item.image) {
            liItem += `<img class="mention_image" src="${item.image}" >`;
          }

          liItem += '<span>';

          if (item.name) {
            liItem += `<strong class="mention_name">${item.name}</strong>`;
          }

          const currentMentionDelimeter = self.currentMentionDelimeter !== '#' ? self.currentMentionDelimeter : '';

          if (item.likes_str && item.checkins && self.currentMentionDelimeter !== ':') {
            liItem += `<strong class="mention_username">
                ${item.likes_str} - ${Utils.formatEngagementNumber(item.checkins, true)} ${window.lookup('people checked in here')}</strong>`;
          } else if (self.currentMentionDelimeter === ':' && item.username) {
            liItem += `<strong class="mention_username"> :${item.username}:</strong>`;
          } else if (item.username) {
            liItem += `<span class="mention_username"> ${currentMentionDelimeter}${item.username}</span>`;
          }

          liItem += '</span>';

          if (item?.profile_type === 'company') {
            liItem += '<svg class="mention_li_type"><use xlink:href="#svg-icon-li-company"></use></svg>';
          }
          if (item?.profile_type === 'user') {
            liItem += '<svg class="mention_li_type"><use xlink:href="#svg-icon-li-person"></use></svg>';
          }

          liItem += '</a></li>';

          return liItem;
        },
        insert(item) {
          const strSelected = self.currentMentionDelimeter + item.username;

          setTimeout(() => {
            self.updateEditor();
            self.options.onMentionInserted();
            Backbone.trigger('auditor-event::tag-selected', self.messageState);
          }, 0);

          if (self.currentMentionDelimeter === ':') {
            return item.image;
          }

          // remove extra spaces which cause encoding problems
          item.codename = Utils.removeExtraSpacesInString(item.codename);
          item.name = Utils.removeExtraSpacesInString(item.name);
          item.username = Utils.removeExtraSpacesInString(item.username);
          item.value = Utils.removeExtraSpacesInString(item.value);

          if (self.mentionTaggingFor === 'facebook') {
            self.updateTagTables('facebookTagTable', item.username, item.codename);
          } else if (self.mentionTaggingFor === 'linkedin') {
            self.updateTagTables('linkedinTagTable', item.username, item.codename);
          } else if (self.mentionTaggingFor === 'instagram') {
            self.updateTagTables('instagramTagTable', item.username, item.username);
          } else if (self.mentionTaggingFor === 'threads') {
            self.updateTagTables('threadsTagTable', item.username, item.username);
          } else if (self.mentionTaggingFor === 'bluesky') {
            self.updateTagTables('blueskyTagTable', item.username, item.username);
          } else if (self.mentionTaggingFor === 'twitter') {
            self.updateTagTables('twitterTagTable', item.username, item.username);
          }

          Utils.sendGAUsageTracking({
            hitType: 'event',
            eventCategory: 'Publishing',
            eventAction: 'Used Content',
            eventLabel: 'Used Profile Tag Selector',
            eventValue: 2,
          });

          return self.prepareMentionInsert(
            self.mentionTaggingFor,
            strSelected,
            item.profile_id,
            item.username,
            item.codename,
            item.profile_type,
          );
        },
      },
      paste_retain_style_properties: 'all',
      paste_auto_cleanup_on_paste: true,
      paste_remove_styles: true,
      paste_remove_styles_if_webkit: true,
      paste_strip_class_attributes: 'all',
      paste_preprocess(plugin, args) {
        // this function checks if the paste content contains
        // markup and notifies the user if it does.

        args.content = self.convertEmojiImagesToCodes(args.content, true);

        // if in plain mode remove style tags
        if (self.mode === 'plain' && (args.content.indexOf('<style') !== -1 || args.content.indexOf('<STYLE') !== -1)) {
          args.content = args.content.replace(/<style.*>[\w\W]{1,}(.*?)[\w\W]{1,}<\/style>/gi, '');
        }

        if (self.mode === 'plain') {
          args.content = args.content.replace(/<\/p>/g, '\n\n'); // convert paras to linebreaks
          args.content = args.content.replace(/<\/?[^>]+(>|$)/g, ''); // remove HTML tags
          args.content = args.content.replace(/[\r\n]/gmi, '<br>'); // convert newlines to br
        }

        // if in plain mode remove table and tbody tags
        if (self.mode === 'plain' && (args.content.indexOf('<table') !== -1 || args.content.indexOf('<tbody') !== -1)) {
          args.content = args.content.replace(/<table/gi, '<span');
          args.content = args.content.replace(/<\/table>/gi, '</span>');
          args.content = args.content.replace(/<tbody/gi, '<span');
          args.content = args.content.replace(/<\/tbody>/gi, '</span>');
          args.content = args.content.replace(/<\/td>/gi, '&nbsp;</td>');
        }

        // if plain text mode and img in pasted content then warn users
        if (self.mode === 'plain' && args.content.indexOf('<img') !== -1) {
          Utils.notify(`${window.lookup('Pasted images are not currently visible but will appear in rich text mode')}.`, 'alert', null, true);

          // add image urls inside hideInRich tags, after img tags
          args.content = args.content.replace(/<img[\s\S]*?src=["']([^"]+)["'][^>]+>/gi, '$&<span class="hideInRichMode">$1 </span>');
        }

        args.content = self.checkEmojisInString(args.content);

        // if content contains css modifier "!important" remove this
        // this will ensure the plain text styles can overide inline
        // styles
        args.content = args.content.replace(/<[^>]+(!important)[^>]+>/gmi, (matched) => matched.replace(/!important/gmi, ''));

        if (self.detectHTML(args.content)) {
          args.preventDefault();

          if (!self.isRitchModeAllowed()) {
            Utils.notify(`${window.lookup("You're trying to paste HTML")}. ${window.lookup('You cannot paste HTML when the editor is in plain text mode')}.`, 'alert', null, true);
            return;
          }

          // if rich mode is allowed then switch to rich mode and
          // allow user to paste html
          self.switchMode('rich');

          self.openHtml();

          Utils.notify(`${window.lookup("You're trying to paste HTML")}. ${window.lookup('Please paste again into the HTML editor below')}.`, 'alert', null, true);
        }
      },
    });

    if (this.options.placeholderText) {
      // add placeholder text to editor
      $(`#${this.options.selector}`).parent().append(`<p class="placeholder-text placeholder-${this.options.selector} muted">${this.options.placeholderText}</p>`);

      this.$placeHolder = $(`#${this.options.selector}`).parent().find(`.placeholder-${this.options.selector}`);

      this.$placeHolder.on('click', () => {
        try {
          self.setFocus();
          self.setContent('<span></span>');
        } catch (err) {
          reportErrorToFaro(err, 'RTEView paste_preprocess');

          // do nothing
        }

        self.$placeHolder.remove();
      });

      this.setPlaceholderPosition(this.mode);

      this.options.placeholderText = false;
    }
  },

  handleTagClick(e) {
    let strhref;
    let win;
    const self = this;

    if (this.isTagInvalidForService(this.messageState.$domBody[0].className, e.target.className)) {
      setTimeout(() => {
        window.tinyMCE.activeEditor.dom.remove(e.target);
        self.updateEditor();
        self.moveCursorToEndOfLine();
        self.options.onUserTyped(self.messageState, true);
        Backbone.trigger('auditor-event::user-typed', self.messageState);
        setTimeout(() => {
          Backbone.trigger('auditor-event::tab-clicked', self.messageState);
        }, 1000);
      }, 0);
    } else {
      strhref = e.target.getAttribute('href');
      win = window.open(strhref, '_blank');
      win.focus();
    }
  },

  setMainMessageToCustomised() {
    if (this.options.selector === 'compose-message') {
      this.isCustomised = true;
    }
  },

  handleEditorClicked() {
    if (this.emojiPicker) {
      this.emojiPicker.close();
    }
    if (this.onclickEventCallback) {
      this.onclickEventCallback();
    }
  },

  updateTagTables(tagTable, username, codename) {
    if (!this.messageState[tagTable]) {
      this.messageState[tagTable] = {};
    }

    tagTable = this.messageState[tagTable];

    tagTable[username] = codename;
  },

  prepareMentionInsert(serviceType, strSelected, profile_id, profile_username, profile_codename, profile_type) {
    let linkTag;
    let strSelectedInstaLink;
    let strEndOfInsert = '&nbsp;';

    if (Utils.isEdge) {
      strEndOfInsert = '<span>&nbsp;</span>';
    }

    if (serviceType === 'facebook') {
      linkTag = `<a target="_blank"
                    href="http://www.facebook.com/${profile_id}"
                    class="${serviceType}-tag-it"
                    data-mce-href="http://www.facebook.com/${profile_id}">${strSelected}</a>${strEndOfInsert}`;
    } else if (serviceType === 'twitter') {
      linkTag = `<a target="_blank"
                    href="http://twitter.com/${strSelected}"
                    class="${serviceType}-tag-it"
                    data-mce-href="http://twitter.com/${strSelected}">${strSelected}</a>${strEndOfInsert}`;
    } else if (serviceType === 'threads') {
      linkTag = `<a target="_blank"
                    href="https://threads.net/${strSelected}"
                    class="${serviceType}-tag-it"
                    data-mce-href="http://threads.net/${strSelected}">${strSelected}</a>${strEndOfInsert}`;
    } else if (serviceType === 'bluesky') {
      const strSelectedBlueskyLink = strSelected.replace('@', '');
      linkTag = `<a target="_blank"
                    href="https://bsky.app/profile/${strSelectedBlueskyLink}"
                    class="${serviceType}-tag-it"
                    data-mce-href="https://bsky.app/profile/${strSelectedBlueskyLink}">${strSelected}</a>${strEndOfInsert}`;
    } else if (serviceType === 'instagram') {
      strSelectedInstaLink = strSelected.replace('@', '');
      linkTag = `<a target="_blank"
                    href="https://www.instagram.com/${strSelectedInstaLink}/"
                    class="${serviceType}-tag-it"
                    data-mce-href="https://www.instagram.com/${strSelectedInstaLink}/">${strSelected}</a>${strEndOfInsert}`;
    } else if (serviceType === 'linkedin' && profile_type === 'user' && window.Utils?.liCompanyPageAccountID) {
      const userDetails = loginContext.getDefaultLoginDetails();
      const liHref = `${window.api_url}/api/v3/linkedin/person_profile_redirect?username=${userDetails.username}&access_token=${userDetails.accessToken}&person_id=${profile_id}&account_id=${window.Utils.liCompanyPageAccountID}`;
      linkTag = `<a target="_blank"
                    href="${liHref}"
                    class="${serviceType}-tag-it"
                    data-mce-href="${liHref}">${strSelected}</a>${strEndOfInsert}`;
    } else if (serviceType === 'linkedin') {
      linkTag = `<a target="_blank"
                    href="https://www.linkedin.com/company/${profile_id}"
                    class="${serviceType}-tag-it"
                    data-mce-href="https://www.linkedin.com/company/${profile_id}">${strSelected}</a>${strEndOfInsert}`;
    }

    return linkTag;
  },

  displayMentionsFor_facebook(query, process, account_id) {
    const checkCache = this.readCache(`fbTag-${query}`);
    const sign = this.serviceIcons.facebook;
    const self = this;

    if (checkCache && checkCache.length) {
      process(checkCache, null, fbSign + window.lookup('This @mention applies to Facebook.'), 'facebook');
      this.mentionFetching = false;
    } else {
      this.socialProfiles.fetch({
        type: 'facebook',
        account_id,
        query,
        success() {
          const tagsList = self.getSocialProfilesForMentions();

          self.mentionFetching = false;

          if (tagsList.length === 0) {
            // only show error message if cache is empty
            if (!checkCache || (checkCache && !checkCache.length)) {
              process(null, true, sign + window.lookup('No results found'), self.mentionTaggingFor);
            }

            return;
          }

          process(tagsList, null, sign + window.lookup('This @mention applies to Facebook.'), self.mentionTaggingFor);
        },
        error(data, response) {
          // only show error message if cache is empty
          if (response && response.message) {
            process(null, true, sign + response.message, self.mentionTaggingFor);
            return;
          }

          if (!checkCache || (checkCache && !checkCache.length)) {
            process(
              null,
              true,
              sign + window.lookup('No results found - try again later.'),
              self.mentionTaggingFor,
            );
          }
        },
      });
    }
  },

  displayMentionsFor_linkedin(query, process, account_id) {
    const checkCache = this.readCache(`liTag-${query}`);
    const sign = this.serviceIcons.linkedin;
    const self = this;

    if (checkCache && checkCache.length) {
      process(checkCache, null, sign + window.lookup('This @mention applies to LinkedIn.'), 'linkedin');
      this.mentionFetching = false;
    } else {
      this.socialProfiles.fetch({
        type: 'linkedin',
        account_id,
        query,
        success() {
          const tagsList = self.getSocialProfilesForMentions();

          self.mentionFetching = false;

          if (tagsList.length === 0) {
            // only show error message if cache is empty
            if (!checkCache || (checkCache && !checkCache.length)) {
              process(null, true, sign + window.lookup('No results found'), self.mentionTaggingFor);
            }

            return;
          }

          process(tagsList, null, sign + window.lookup('This @mention applies to LinkedIn.'), 'linkedin');
        },
        error(data, response) {
          if (response && response.message) {
            process(null, true, self.serviceIcons.linkedin + response.message, self.mentionTaggingFor);
            return;
          }

          // only show error message if cache is empty
          if (!checkCache || (checkCache && !checkCache.length)) {
            process(
              null,
              true,
              sign + window.lookup('No results found - try again later.'),
              self.mentionTaggingFor,
            );
          }
        },
      });
    }
  },

  displayMentionsFor_instagram(query, process) {
    const sign = this.serviceIcons.instagram;
    const self = this;
    const queryTrimmed = query.substr(0, 30);
    const tagsList = [{
      username: queryTrimmed,
      name: queryTrimmed,
      image: '/images/empty-avatar.jpg',
    }];

    self.mentionFetching = false;
    self.applyProcess(queryTrimmed, tagsList, process, sign + window.lookup('This @mention applies to Instagram.'), 'instagram');
  },

  displayMentionsFor_twitter(query, process) {
    const sign = this.serviceIcons.twitter;
    const queryTrimmed = query.substr(0, 30);
    const tagsList = [{
      username: queryTrimmed,
      name: queryTrimmed,
      image: '/images/empty-avatar.jpg',
    }];

    this.mentionFetching = false;
    this.applyProcess(queryTrimmed, tagsList, process, sign + window.lookup('This @mention applies to Twitter.'), 'twitter');
  },

  displayMentionsFor_threads(query, process) {
    const sign = this.serviceIcons.threads;
    const queryTrimmed = query.substr(0, 30);
    const tagsList = [{
      username: queryTrimmed,
      name: queryTrimmed,
      image: '/images/empty-avatar.jpg',
    }];

    this.mentionFetching = false;
    this.applyProcess(queryTrimmed, tagsList, process, sign + window.lookup('This @mention applies to Threads.'), 'threads');
  },

  displayMentionsFor_bluesky(query, process) {
    const sign = this.serviceIcons.bluesky;
    const queryTrimmed = query.substr(0, 30);
    const queryProcessed = queryTrimmed.includes('.') ? queryTrimmed : `${queryTrimmed}.bsky.social`;

    const tagsList = [{
      username: queryProcessed,
      name: queryProcessed,
      image: '/images/empty-avatar.jpg',
    }];

    this.mentionFetching = false;
    this.applyProcess(queryTrimmed, tagsList, process, sign + window.translate('mention_bluesky'), 'bluesky');
  },

  applyProcess(query, data, process, title, socialType) {
    const listItems = data || [];

    if (listItems && listItems.length) {
      process(listItems, null, title, socialType);
    }
  },

  setupEmojiPicker() {
    const self = this;

    if (!this.options.$emojiPickerTrigger) {
      return;
    }

    this.emojiPicker = new EmojiPickerView({
      $pickerTrigger: this.options.$emojiPickerTrigger,
      onSelect: _.bind(function (emojiCode) {
        this.insertTextAtCursor(emojiCode);
        this.messageState.$domBody.find('.emoji').attr('data-mce-resize', 'false');
      }, self),
      app: this.options.parent.app,
      composeView: this.options.parent,
      serviceType: Utils.sanitiseServiceName(this.options.selector),
    });

    Utils.$body.append(this.emojiPicker.render().el);

    // On parent clicked
    if (this.options.parent) {
      this.options.parent.$el.on('click drag-start', () => {
        self.emojiPicker.close();
      });

      this.options.parent.$el.find('.modal-body').scroll(() => {
        self.emojiPicker.close();
      });
    }
  },

  beforeSwitch() {
    if (this.emojiPicker) {
      this.emojiPicker.cleanup();
    }
  },
  setFacebookTagTable(facebookTagTable) {
    this.messageState.facebookTagTable = facebookTagTable;
  },

  setTwitterTagTable(twitterTagTable) {
    this.messageState.twitterTagTable = twitterTagTable;
  },

  setThreadsTagTable(threadsTagTable) {
    this.messageState.threadsTagTable = threadsTagTable;
  },

  setBlueskyTagTable(blueskyTagTable) {
    this.messageState.blueskyTagTable = blueskyTagTable;
  },

  setInstagramTagTable(instagramTagTable) {
    this.messageState.instagramTagTable = instagramTagTable;
  },

  setLinkedinTagTable(linkedinTagTable) {
    this.messageState.linkedinTagTable = linkedinTagTable;
  },

  hasTwitterTag() {
    let has = false;
    const that = this;

    _.each(this.messageState.twitterTagTable, (value) => {
      has = that.messageState.msgText.indexOf(value) !== -1;
    });

    return has;
  },

  setFocus() {
    if ((typeof window.tinymce === 'undefined')
                || !this.tmceEditor
                || (this.tmceEditor && typeof this.tmceEditor.getDoc() === 'undefined')
                || (this.options.selector == 'hiddenTinymcePrimer')) {
      return;
    }

    this.tmceEditor.focus();
  },

  isTagInvalidForService(parentClassName, tagClassName) {
    const arClassName = tagClassName.split('-');
    const type = arClassName[1];

    tagClassName = arClassName[0];

    if (parentClassName.indexOf('compose-message-editor') !== -1
                || type === 'hashtag') {
      return false;
    }

    return parentClassName.indexOf(tagClassName) === -1;
  },

  addErrorIcon(type) {
    this.$tab.addClass(`in-${type}`);
  },

  removeErrorIcon(type) {
    this.$tab.removeClass(`in-${type}`);
  },

  addNotificationMessage(notification, composeId) {
    // if error message exists already then do nothing
    // or if notification was closed then don't display
    if (this.$notifySection.find(`.alert[data-id="${notification.idName}"]`).length
            || this.arClosedNotifications.indexOf(notification.idName) !== -1) {
      return;
    }

    let $notify;
    if (notification.idName) {
      $notify = $(this.notifyTemplate({
        idName: notification.idName,
        alertClass: notification.type,
        alertTitle: notification.title,
        alertText: notification.text,
        showActionButton: notification.showActionButton,
        showCloseButton: notification.showCloseButton,
        actionBtnText: notification.actionBtnText,
        isOverMax: notification.isOverMax,
      }));
    }

    this.removePlaceholderText(true);

    this.addNotifyBehaviour(notification, $notify, composeId);

    if ($notify) {
      this.$notifySection.append($notify);
      $notify.show();
    }
  },

  clearAllNotificationMessages() {
    this.$notifySection.empty();
    this.$counterSection.find('.highlight').removeClass('highlight');
  },

  removeNotificationMessage(idName) {
    this.$notifySection.find(`.alert[data-id="${idName}"]`).remove();
  },

  handleNotificationClose(e) {
    const idName = $(e.currentTarget).parent().attr('data-id');
    this.$notifySection.find(`.alert[data-id="${idName}"]`).hide();
    this.arClosedNotifications.push(idName);
  },

  addNotifyBehaviour(notification, $notify, composeId) {
    const { idName } = notification;
    let reconnection;
    const that = this;

    if ($notify) {
      $notify.find('.close').on('click', _.bind(this.handleNotificationClose, this));
    }

    switch (idName) {
      case 'service-disconnected':
        if (notification.reconnection_data) {
          reconnection = notification.reconnection_data;
          $notify.find('.action-a').on('click', () => {
            Utils.addService(reconnection.service_id, reconnection.account_id, () => {
              this.checkIfReconnected(reconnection);
            });
          });
        }
        break;
      case 'character-limit':
        this.$counterSection.find(`.${Utils.sanitiseServiceName(composeId)}-section`).addClass('highlight');
        break;
      case 'max-hashtags':
        this.$counterSection.find(`.${Utils.sanitiseServiceName(composeId)}-hashtag-section`).addClass('highlight');
        break;
      case 'invalid-media-attached':
      case 'bigmedia-attached':
      case 'invalid-filetype':
      case 'pdf-page-limit':
      case 'animated-gif':
      case 'instagrambusiness-mediaoversize':
        $notify.find('.action-a').on('click', () => {
          if (this.isModalOpening) {
            return;
          }
          this.setIsModalOpening(1000);

          if (notification.media_type && (notification.media_type.indexOf('video') !== -1 || notification.media_type.includes('pdf'))) {
            this.options.$attachBtn.trigger('click');
          } else {
            this.$attachmentSection.find(`#${notification.media_id} .change-image`).trigger('click');
          }
          // this is called to keep the send button in the disabled state
          Backbone.trigger('publishing-notification-required', {});
        });

        this.$attachmentSection.find(`#${notification.media_id} .remove-attachment`).on('click', () => {
          Backbone.trigger('publishing-notification-required', {});
        });
        break;
      case 'story-wrong-image-ratio':
        $notify.find('.action-a').on('click', () => {
          if (this.isModalOpening) {
            return;
          }

          this.setIsModalOpening(1000);
          that.$attachmentSection.find(`#${notification.media_id} .btn-edit`).trigger('click');
        });
        break;
      case 'invalidimage-ratio':
      case 'linkedinsuggested-ratio':

        if (notification.disableEditImageBtn) {
          that.$attachmentSection.find(`#${notification.media_id} .btn-edit`).remove();
        }
        $notify.find('.action-a').on('click', () => {
          if (notification.disableEditImageBtn) {
            that.$attachmentSection.find(`#${notification.media_id} .change-image`).trigger('click');
          } else {
            that.$attachmentSection.find(`#${notification.media_id} .btn-edit`).trigger('click');
          }

          // this is called to keep the send button in the disabled state
          Backbone.trigger('publishing-notification-required', {});
        });
        break;
      case 'media-notattached':
        $notify.find('.action-a').on('click', () => {
          if (this.isModalOpening) {
            return;
          }
          this.setIsModalOpening(1000);

          this.options.$attachBtn.trigger('click');

          Backbone.trigger('publishing-notification-required', {});
        });
        break;
      case 'ismin-max-videolength':
      case 'instagrambusiness-wrong-video-codec':
      case 'isvideo-over-max-width':
      case 'isvideo-under-min-width':
      case 'wrong-video-aspectratio':
      case 'wrong-video-resolution':
        this.setupMediaConfirmation(
          $notify,
          window.lookup('Remove video?'),
          window.lookup('Are you sure you want to remove this video?'),
        );
        break;
      case 'video-title-toolong':
      case 'youtube-video-title-toolong':
        $notify.find('.action-a').on('click', () => {
          Backbone.trigger(
            `requested::edit-video-details-${Utils.sanitiseServiceName(this.options.selector)}`,
          );
        });
        break;
      default:
    }
  },

  checkIfReconnected(reconnectionData) {
    const account = new AccountModel({
      id: reconnectionData.account_id,
    });

    account.fetch({
      refreshCache: true,
      success: _.bind((model, response) => {
        // if reconnected the trigger reconnected event
        if (response && response.reconnection_info && response.reconnection_info.needs_reconnecting) {
          // it still needs reconnecting so do nothing as the notification
          // should already be displayed in this case
        } else {
          Backbone.trigger('auditor-event::account-reconnected', reconnectionData.account_id);
        }
      }),
    });
  },

  setIsModalOpening(timeout) {
    this.isModalOpening = true;

    setTimeout(() => {
      this.isModalOpening = false;
    }, timeout);
  },

  setupMediaConfirmation($notify, header, body) {
    $notify.find('.action-a').on('click', () => {
      Utils.confirm(
        header,
        body,
        window.lookup('No'),
        window.lookup('Yes'),
        () => {
          Backbone.trigger('close-video-no-confirm');
          setTimeout(() => {
            this.options.$attachBtn.trigger('click');
            Backbone.trigger('publishing-notification-required', {});
          }, 500);
        },
      );
    });
  },

  handleClickInvalidRatioEdit() {
    const { attachmentDetailViews } = this.options.parent.attachmentView.activePanel;
    const invalidImage = _.find(attachmentDetailViews, (attachmentDetailView) => attachmentDetailView.file.param_file.ratio_invalid);

    if (!invalidImage) {
      return;
    }

    invalidImage.$el.find('.btn-edit').click();

    Backbone.trigger('publishing-notification-required', {});
  },

  minimizeEditor() {
    const $body = this.messageState.$domBody;

    this.isMaximised = false;

    if ($body) {
      this.editor_ifr.style.height = this.currentMinHeight;
      $body.css('minHeight', '54px');
    }
  },

  maximizeEditor() {
    const $body = this.messageState.$domBody;

    this.isMaximised = true;

    if ($body) {
      this.editor_ifr.style.height = `${this.options.maxEditorHeight}px`;
      $body.css('minHeight', `${this.options.maxEditorHeight - 20}px`);
    }
  },

  displayMentionsFor_Emojis(query, process) {
    process(this.emojiList);
  },

  prepopulateEmojiList() {
    let i = 0;
    const autoCompleteEmojiList = [];

    for (i; i < emojisArray.length; i++) {
      autoCompleteEmojiList.push({
        username: emojisArray[i].aliases[0],
        name: emojisArray[i].description,
        image: emojisArray[i].emoji,
      });
    }

    return autoCompleteEmojiList;
  },

  getSocialProfilesForMentions() {
    const autoCompleteProfileList = [];
    const that = this;

    this.socialProfiles.each((profile) => {
      let userProfile;
      let pic = '';
      let LiCodename = '';

      if (that.mentionTaggingFor === 'facebook') {
        userProfile = {
          profile_id: profile.get('profile_id_str'),
          codename: `[fb_${profile.get('profile_name')}:${profile.get('profile_id_str')}]`,
          username: profile.get('profile_name'),
          name: profile.get('name'),
          image: profile.get('profile_picture'),
        };

        if (profile.get('checkins')) {
          userProfile.checkins = profile.get('checkins');
        }

        if (profile.get('likes_str')) {
          userProfile.likes_str = profile.get('likes_str');
        }
      } else if (that.mentionTaggingFor === 'linkedin') {
        if (profile.get('profile_picture')) {
          pic = profile.get('profile_picture');
        } else {
          pic = '/images/empty-avatar.jpg';
        }

        if (profile.get('profile_type') && profile.get('profile_type') === 'company') {
          LiCodename = `[li_${profile.get('profile_name')}:${profile.get('profile_id')}]`;
        }

        if (profile.get('profile_type') && profile.get('profile_type') === 'user') {
          LiCodename = `[liperson_${profile.get('profile_name')}:${profile.get('profile_id')}]`;
        }

        userProfile = {
          profile_id: profile.get('profile_id'),
          codename: LiCodename,
          username: profile.get('profile_name'),
          name: profile.get('profile_name'),
          profile_type: profile.get('profile_type'),
          image: pic,
        };
      } else if (that.mentionTaggingFor === 'instagram' && that.currentMentionDelimeter === '#') {
        userProfile = {
          username: `${window.globalObject.formatNumber(profile.get('media_count'))} ${window.lookup('posts')}`,
          name: `#${profile.get('name')}`,
        };
      } else {
        userProfile = {
          username: profile.get('profile_id'),
          name: `${profile.get('first_name')} ${profile.get('last_name')}`,
          image: profile.get('profile_picture'),
        };
      }

      autoCompleteProfileList.push(userProfile);
    });

    return autoCompleteProfileList;
  },

  onClickEvent(callback) {
    this.onclickEventCallback = callback;

    if (this.tmceEditor) {
      this.tmceEditor.on('click', callback);
    }
  },

  /*
        Editor event handler methods
    */
  onPasted() {
    this.hasPasted = true;

    this.updateMessageStateText(true);
    this.updateMessageStateLinks();
    this.onSpaceEnterPasteChangeEvent();
    this.messageState.hasContentChanged = true;
    this.messageState.changeType = 'paste';
    this.messageState.lastKeypressCode = null;

    this.updateMessageStateText();

    this.handleusertyped();
  },

  handleusertyped(notUserTriggerred) {
    this.removePlaceholderText();
    this.setMainMessageToCustomised();
    this.options.onUserTyped(this.messageState, notUserTriggerred);
  },

  updatePlaceholderText(strText) {
    if (this.$placeHolder) {
      this.$placeHolder.html(strText);
    }
  },

  removePlaceholderText(forceRemove) {
    const $placeHolder = $(`#${this.options.selector}`).parent().find(`.placeholder-${this.options.selector}`);

    if ($placeHolder && this.messageState.msgTextLength > 0) {
      $placeHolder.remove();
    }

    if ($placeHolder && forceRemove) {
      $placeHolder.remove();
    }
  },

  handleKeyDown(event) {
    const { selection } = window.tinymce.activeEditor;
    const selectionContent = this.tmceEditor.selection.getContent();
    const arNonCharactersA = [8, 32, 37, 38, 39, 40, 46];
    const nodeName = selection.getNode().className;

    // https://css-tricks.com/snippets/javascript/javascript-keycodes/ - to see specific keycodes
    if ((nodeName.match(/^(facebook|twitter|instagram)-tag-it$/)
                && arNonCharactersA.indexOf(event.keyCode) === -1)) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }

    if (!Utils.isIE && (event.keyCode >= START_KEYCODE && event.keyCode <= END_KEYCODE && !event.ctrlKey && !event.metaKey && selectionContent.length)) {
      selection.setContent(event.key);
      return false;
    }
    return true;
  },

  onKeyUp(e) {
    const keypressCode = e.which || e.keyCode;

    this.messageState.changeType = 'keyup';

    this.messageState.lastKeypressCode = keypressCode;

    if (e.ctrlKey) {
      this.isCTRLPressed = false;
    }

    // if up,down,left,right,shift,ctrl,alt,pgDn,pgUp,Home,Insert
    // pressed then do nothing, i.e return
    if ([38, 39, 40, 37, 16, 17, 18, 35, 34, 33, 45, 36].indexOf(keypressCode) != -1 || this.hasPasted) {
      this.hasPasted = false;
      this.messageState.hasContentChanged = false;
      this.handleusertyped();
      return;
    }

    const character = String.fromCharCode(keypressCode);

    this.lastTypedCharacter = character;

    this.updateMessageStateText();

    if (character == ' ' || keypressCode == 13) {
      // regex check on space or enter pressed
      // this is also triggered on the paste event
      this.updateMessageStateLinks();
      this.onSpaceEnterPasteChangeEvent();
    }

    this.messageState.hasContentChanged = true;

    this.handleusertyped();
  },

  checkEmojis() {
    let matchEmojis;
    let content;

    if (!this.tmceEditor) {
      return;
    }

    content = this.tmceEditor.getContent();

    if (content) {
      matchEmojis = content.match(/:[\w+-]+:/);
    } else if (!content) {
      return;
    }

    // check if emoji code needs replacing
    if (matchEmojis) {
      content = Utils.processEmojiText(content, false);
      this.setContent(content);
      // add the number of emojis to counter
    }
  },

  checkEmojisInString(text) {
    if (text.match(/:[\w+-]+:/)) {
      return Utils.processEmojiText(text, false);
    }
    return text;
  },

  convertEmojiImagesToCodes(content, retainHTMLArg) {
    const retainHTML = (typeof retainHTMLArg !== 'undefined') ? retainHTMLArg : false;

    const $preText = $(`<div>${content}</div>`);

    // remove dummy emoji codes
    if (content.indexOf('class="emoji-code"') !== -1) {
      $preText.find('span.emoji-code').remove();
    }

    // if no img emoji present then return content unprocessed
    if (content.indexOf('class="emoji"') == -1) {
      if (retainHTML) {
        return $preText.html();
      }
      return $preText.text();
    }

    $preText.find('img.emoji').each(function () {
      const $emoji = $(this);
      const code = `:${$emoji.attr('data-code')}:`;

      $emoji.replaceWith(code);
    });

    return $preText.text();
  },

  updateMessageState(messageStateToCopy) {
    const messageState = $.extend(true, {}, messageStateToCopy);

    this.messageState.arHrefLinks = messageState.arHrefLinks;
    this.messageState.arIncompleteLinks = messageState.arIncompleteLinks;
    this.messageState.arShortenedLinks = messageState.arShortenedLinks;
    this.messageState.arTextLinks = messageState.arTextLinks;
  },

  updateMessageStateText(fromPaste) {
    const pasteDefectNo = fromPaste ? 2 : 0;
    let preText;
    let igFirstCommentText = '';

    if (!this.messageState.$domBody) {
      return;
    }

    // update the messageState
    preText = this.messageState.$domBody.html();

    // update the Instagram First Comment
    if (this.options.$igFirstCommentField) {
      igFirstCommentText = this.options.$igFirstCommentField.val();
    }

    if (preText.indexOf('\uFEFF') !== -1
            || preText.indexOf('<br') !== -1
            || preText.indexOf('</p') !== -1
            || preText.indexOf('&nbsp') !== -1) {
      preText = preText.replace(/\uFEFF/g, '');

      preText = Utils.replaceAll(preText, '<br>', '\n', true);
      preText = Utils.replaceAll(preText, '<br/>', '\n', true);
      preText = Utils.replaceAll(preText, '</p>', '\n', true);
      preText = Utils.replaceAll(preText, '&nbsp;', ' ', true);
    }

    if (preText.indexOf('<img') !== -1
            || preText.indexOf('<video') !== -1
            || preText.indexOf('<audio') !== -1
            || preText.indexOf('<picture') !== -1
            || preText.indexOf('<svg') !== -1) {
      this.messageState.hasInlineMedia = true;
      this.hasInlineMedia = true;
    } else {
      this.messageState.hasInlineMedia = false;
      this.hasInlineMedia = false;
    }

    this.messageState.hasInstagramHashtag = preText.indexOf('instagram-hashtag-it') !== -1;
    this.messageState.hasTwitterHashtag = preText.indexOf('twitter-hashtag-it') !== -1;

    this.messageState.msgText = this.convertEmojiImagesToCodes(preText);
    this.messageState.igFirstCommentText = igFirstCommentText;

    if (this.messageState.msgText.charAt(this.messageState.msgText.length - 1) == '\n') {
      this.messageState.msgText = this.messageState.msgText.substr(0, this.messageState.msgText.length - 1);
    }

    // remove twitter or FB tag tables if no '@' in msgText
    if (this.messageState.msgText.indexOf('@') == -1) {
      delete this.messageState.linkedinTagTable;
      delete this.messageState.facebookTagTable;
      delete this.messageState.twitterTagTable;
      delete this.messageState.threadsTagTable;
      delete this.messageState.blueskyTagTable;
      delete this.messageState.instagramTagTable;
    }

    if (typeof this.messageState.msgText !== 'undefined') {
      this.messageState.msgTextLength = (this.messageState.msgText.length - pasteDefectNo);
    }

    this.messageState.selector = this.options.selector;

    this.debounced_updateEditorHeight();
  },

  updateEditor() {
    this.updateMessageStateText();
    this.updateMessageStateLinks();
  },

  updateEditorHeight() {
    let newlines;
    let newHeight;
    let linesInText = 0;
    const TinyMCEHeight = this.messageState.$domBody.height();

    if (this.isMaximised == true) {
      return;
    }

    if (this.container && this.editor_ifr) {
      newlines = (this.messageState.msgText.match(/\n/g) || []).length;
      linesInText = parseInt((this.messageState.msgTextLength / 88), 10) + newlines;

      if (linesInText > 1) {
        if (TinyMCEHeight < 70) {
          newHeight = 20 + (linesInText * 23);
        } else {
          newHeight = this.messageState.$domBody.height() + 30;
        }
      } else {
        newHeight = 70;
      }

      this.editor_ifr.style.height = `${newHeight}px`;
      this.currentMinHeight = `${newHeight}px`;
    }
  },

  updateMessageStateLinks() {
    if (!this.messageState.$domBody) {
      return;
    }

    const $body = this.messageState.$domBody;
    const text = this.messageState.msgText;
    const that = this;

    // check for links in 'a' tags
    // if in rich mode
    if (this.mode == 'rich') {
      this.messageState.arHrefLinks = [];

      $body.find('a').each(function () {
        const href = this.getAttribute('href');

        // if is a tag or hashtag then don't collect link
        if (this.getAttribute('data-mce-href')) {
          return;
        }

        if (href && href !== '') {
          that.messageState.arHrefLinks.push(href);
        }
      });
    } else {
      this.messageState.arHrefLinks = [];
    }

    // and check for links in text
    this.messageState.arTextLinks = Utils.extractLinks(text) || [];

    // finally check for incomplete links
    this.messageState.arIncompleteLinks = Utils.extractIncompleteLinks(text);
  },

  onSpaceEnterPasteChangeEvent() {
    // shorten links
    if ((this.messageState.arTextLinks.length || this.messageState.arHrefLinks.length) && !this.fetchingShortenedLinks) {
      this.shortenAllLinks();
    }
  },

  shortenAllLinks() {
    if (this.options.noShortenLinks) {
      return;
    }
    const objLinksToShorten = {};
    const allLinks = this.messageState.arTextLinks.concat(this.messageState.arHrefLinks);
    const self = this;

    // make hashTable of unshortened links
    const arLinksToShorten = _.filter(allLinks, (link) => {
      let unshortened = self.messageState.arShortenedLinks.indexOf(link) == -1;

      if (unshortened && !Utils.isValidUrl(link)) {
        unshortened = false;
      }

      return unshortened;
    });

    if (arLinksToShorten.length) {
      _.each(arLinksToShorten, (link) => {
        objLinksToShorten[link] = '';
      });

      this.shortenLinks(objLinksToShorten);
    }
  },

  shortenLinks(objLinksToShorten) {
    const arLinks = _.keys(objLinksToShorten);
    const self = this;

    this.fetchingShortenedLinks = true;

    this.options.onBeforeShortenLinks();

    // _.map creates an array of 'promises' which is passed into
    // the 'when' using apply
    $.when
      .apply($, _.map(arLinks, (url) => Sendible.Connect.shorten_URL(window.appConfig.applicationId, $username, $password, url, self.options.guid)))
      .done((...args) => {
        let shortUrl;
        let i = 0;
        let content;

        for (i; i < arLinks.length; i++) {
          shortUrl = arLinks.length === 1 ? args[0].result.url : args[i][0].result.url;

          objLinksToShorten[arLinks[i]] = shortUrl;
          // update the arShortenedLinks array so we can determin
          // which links need shortening in the future
          self.messageState.arShortenedLinks.push(shortUrl);

          if (shortUrl.indexOf('&') !== -1) {
            shortUrl = Utils.replaceAll(shortUrl, '&', '&amp;');
            self.messageState.arShortenedLinks.push(shortUrl);
          }
        }

        if (typeof self.options.parent !== 'undefined'
                && self.options.parent.id === 'compose-box'
                && self.options.parent.$el.css('display') !== 'block'
                && self.options.parent.$el.css('display') !== 'flex') {
          return;
        }

        try {
          content = self.tmceEditor.getContent();
        } catch (e) {
          reportErrorToFaro(e, 'RTEView shortenLinks');

          return;
        }

        content = self.replaceLinksInString(objLinksToShorten, content);
        content = self.replaceURLsWithLinksInString(_.values(objLinksToShorten), content);

        self.setContent(content);

        self.updateEditor();

        self.options.onAfterShortenLinks();

        self.fetchingShortenedLinks = false;
      });
  },

  replaceLinks(objLinks) {
    // objLinks example ={
    //     'http://wired.com': 'http://btly',
    //     'http://bbc.com': 'http://c'
    // }
    let content;

    if (!objLinks || $.isEmptyObject(objLinks)) {
      return;
    }

    content = this.tmceEditor.getContent();

    content = this.replaceLinksInString(objLinks, content);

    this.setContent(content);
  },

  replaceURLsWithLinksInString(links, content) {
    // check urls that are not in an 'a' tag and add them to a tag
    let alteredLink;
    const aTags = [];
    const alteredTags = [];
    const alteredLinks = [];
    let strRXUrls = '';
    let strRXAltUrls = '';
    let regexLookupAltUrls;

    _.each(links, (url) => {
      aTags.push(`<a href="${url}" >${url}</a>`);
      strRXUrls += `(${url})|`;

      if (url.indexOf('&') !== -1) {
        alteredLink = Utils.replaceAll(url, '&', '&amp;');

        alteredLinks.push(alteredLink);

        alteredTags.push(`<a href="${alteredLink}" >${alteredLink}</a>`);

        strRXAltUrls += `(${alteredLink})|`;
      }
    });

    // remove last '|'
    strRXUrls = strRXUrls.substr(0, strRXUrls.length - 1);
    const regexLookupUrls = new RegExp(strRXUrls, 'g');

    content = content.replace(regexLookupUrls, (...args) => {
      const c1 = args[0];
      const fullContent = args[args.length - 1];
      const urlIndex = args[args.length - 2];

      if (fullContent.substr((urlIndex - 1), 15).match(/.+["|'|<]/g) === null
                    && fullContent.substr(urlIndex + c1.length, 5).match(/\s*["|'|>]/g) === null) {
        return `${aTags[links.indexOf(c1)]}<span>&nbsp;</span>`;
      }

      return c1;
    });

    if (alteredLinks.length) {
      // remove last '|'
      strRXAltUrls = strRXAltUrls.substr(0, strRXAltUrls.length - 1);
      regexLookupAltUrls = new RegExp(strRXAltUrls, 'g');

      content = content.replace(regexLookupAltUrls, (...args) => {
        const c1 = args[0];
        const fullContent = args[args.length - 1];
        const urlIndex = args[args.length - 2];
        // 3rd element in arguments is index, use this to confirm that url is not in anchor tag

        // if the previous character from the url is '"> then dont replace
        if (fullContent.substr((urlIndex - 10), 15).match(/.+["|'|<]/g) !== null
                    && fullContent.substr(urlIndex + c1.length, 5).match(/\s*["|'|>]/g) !== null) {
          return `${alteredTags[alteredLinks.indexOf(c1)]}<span>&nbsp;</span>`;
        }
        return c1;
      });
    }

    return content;
  },

  replaceLinksInString(objLinks, content) {
    let alteredLinks;

    // replace links based on hashtable
    Object.keys(objLinks).forEach((key) => {
      content = content.replace(key, objLinks[key]);
      content = content.replace(key, objLinks[key]);

      if (key.indexOf('&') !== -1) {
        alteredLinks = Utils.replaceAll(key, '&', '&amp;');
        content = content.replace(alteredLinks, objLinks[key]);
        content = content.replace(alteredLinks, objLinks[key]);
      }
    });

    return content;
  },

  saveCache(key, item) {
    const cache = new Cache();

    if (item && item.length) {
      cache.store(key, JSON.stringify(item), 45);
    }
  },

  readCache(key) {
    const cache = new Cache();
    if (cache.read(key)) {
      const result = JSON.parse(cache.read(key));
      return result;
    }
    return [];
  },

  moveCursorToEndOfLine() {
    try {
      if (!this.messageState.$domBody) {
        return;
      }
      this.tmceEditor.selection.select(this.messageState.$domBody[0], true); // ed is the editor instance

      this.tmceEditor.selection.collapse(false);
    } catch (err) {
      reportErrorToFaro(err, 'RTEView moveCursorToEndOfLine');

      console.log('ERROR IN RTEView', err);
    }
  },

  initializeContent(content, prependContent, preventFocus, preventShorten) {
    let intervalId;

    if (!content) {
      return;
    }

    // if content contains css modifier "!important" remove this
    // this will ensure the plain text styles can overide inline
    // styles
    content = content.replace(/<[^>]+(!important)[^>]+>/gmi, (matched) => matched.replace(/!important/gmi, ''));

    if (this.tmceEditor && typeof this.tmceEditor.getDoc() !== 'undefined') {
      // run
      this.performInitContent(content, prependContent, preventFocus, preventShorten);
      this.removePlaceholderText();
    } else {
      intervalId = setInterval(_.bind(function () {
        if (this.tmceEditor && typeof this.tmceEditor.getDoc() !== 'undefined') {
          clearInterval(intervalId);
          this.performInitContent(content, prependContent, preventFocus, preventShorten);
          this.removePlaceholderText();
        }
      }, this), 1000);
    }
  },

  isLastCharASpace(content) {
    const testSpace = content.substr(content.length - 23);

    return /\s+$/.test(content) || testSpace.indexOf('&nbsp;') !== -1;
  },

  setContent(content) {
    const eolLinkRegex = /<a[^>]*>([^<]*)<\/a>$/gi;
    let bodyOnlyContent;
    let tagCheckContent = false;

    if (!this.tmceEditor) {
      return;
    }

    if (content.length) {
      // remove new lines as these effect editor height.
      if (content.indexOf('<!DOCTYPE html>\n<html>\n<head>\n</head>\n<body>') !== -1) {
        content = content.replace('<!DOCTYPE html>\n<html>\n<head>\n</head>\n<body>', '<!DOCTYPE html><html><head></head><body>');
      }

      bodyOnlyContent = this.contentBodyExtractionRegex.exec(content);
      this.contentBodyExtractionRegex.lastIndex = 0;

      if (bodyOnlyContent && bodyOnlyContent[1]) {
        tagCheckContent = this.processTagChecksOnBody(bodyOnlyContent[1]);
      }

      if (tagCheckContent) {
        content = content.replace('</body>', '<span>&nbsp;</span></body>');
      }

      if (this.isLastCharASpace(content)) {
        this.tmceEditor.setContent(`${content.trim()}&nbsp;`, { format: 'raw' });
      } else if (content.match(eolLinkRegex)) {
        this.tmceEditor.setContent(`${content}<span>&nbsp;</span>`);
      } else {
        this.tmceEditor.setContent(content);
      }
      this.moveCursorToEndOfLine();
    }
  },

  processTagChecksOnBody(message) {
    if (message.match(this.anchorTagMatchEndOfBodyRegex)) {
      return message.match(this.anchorTagMatchEndOfBodyRegex);
    }

    if (message.match(this.tagMatchEndOfBodyRegex)) {
      return message.match(this.tagMatchEndOfBodyRegex);
    }

    return false;
  },

  resetLinkDataStructures() {
    this.messageState.arTextLinks = [];
    this.messageState.arShortenedLinks = [];
    this.messageState.arHrefLinks = [];
    this.messageState.arIncompleteLinks = [];
  },

  performInitContent(content, prependContent, preventFocus, preventShorten) {
    content = Utils.processEmojiText(content, false);

    this.setContent(content);

    if (prependContent && prependContent.length) {
      this.messageState.$domBody.prepend(prependContent);
    }

    this.updateEditor();
    this.messageState.hasContentChanged = true;
    this.messageState.changeType = 'textInserted';
    this.messageState.lastKeypressCode = null;

    this.checkEmojis();

    this.handleusertyped(true);

    if (!preventFocus) {
      this.setFocus();
    }

    if (!preventShorten) {
      this.shortenAllLinks();
    }
  },

  openHtml() {
    this.htmlEditor = new HTMLBox({
      content: this.getRichText(true),
      onUpdate: _.bind(function (content) {
        this.setContent(content);
        this.updateEditor();
        Backbone.trigger('auditor-event::user-typed', this.messageState);
      }, this),
    });

    this.htmlEditor.render();
  },

  detectHTML(rawData) {
    if (typeof rawData === 'undefined') {
      return false;
    }

    return (rawData.indexOf('!DOCTYPE') !== -1) || (rawData.indexOf('!doctype') !== -1)
                    || (rawData.indexOf('&lt;div') !== -1 && rawData.indexOf('&lt;/div&gt;') !== -1)
                    || (rawData.indexOf('&lt;body') !== -1 && rawData.indexOf('&lt;/body&gt;') !== -1)
                    || (rawData.indexOf('&lt;table') !== -1 && rawData.indexOf('&lt;/table&gt;') !== -1);
  },

  insertTextAtCursor(strText) {
    window.tinyMCE.activeEditor.execCommand('mceInsertContent', false, strText);

    this.updateEditor();
    this.messageState.hasContentChanged = true;
    this.messageState.changeType = 'textInserted';
    this.messageState.lastKeypressCode = null;

    this.updateMessageStateText();

    this.handleusertyped();

    this.shortenAllLinks();
  },

  addImgAtCursor(file_url) {
    if (file_url.indexOf('base64') !== -1) {
      return;
    }

    this.tmceEditor.execCommand('mceInsertContent', false, `<img src="${file_url}" alt="" />`);
  },

  getMessageState() {
    const { messageState } = this;

    if (this.options.$igFirstCommentField) {
      this.messageState.igFirstCommentText = this.options.$igFirstCommentField.val();
    }

    messageState.hasMedia = this.hasMedia;

    return messageState;
  },

  getTextLinks() {
    return this.messageState.arTextLinks;
  },

  getText(htmlEl) {
    const $editorBody = $(htmlEl);

    return $editorBody.html();
  },

  getPlainText() {
    return this.messageState.msgText || '';
  },

  getRichText(sendRich) {
    if (sendRich && this.tmceEditor) {
      return (this.tmceEditor.getContent({ format: 'raw' })).replace('<br data-mce-bogus="1">', '');
    } if (this.tmceEditor) {
      return this.tmceEditor.getContent();
    }
    return '';
  },

  getRichTextForSave(noShell, removeWrappingNewLines) {
    let richText = this.tmceEditor.getContent();
    const linkEndingSpan = '<br /></a><span> </span>';
    const correctedlinkEnding = '</a><span> </span><br />';
    const spanLength = linkEndingSpan.length + 2;
    let pattern;
    let array_matches;

    const replacer = function (string, matchedText) {
      let value;
      let valueCodeName;

      const regexValue = /data-value=["']([^"']+)/gmi.exec(string);

      if (regexValue !== null && regexValue.length > 1) {
        value = regexValue[1];
      }

      const regexCodeName = /data-codename=["']([^"']+)/gmi.exec(string);

      if (regexCodeName !== null && regexCodeName.length > 1) {
        valueCodeName = $('<div/>').html(regexCodeName[1]).text();
      }

      return `<a href="http://www.facebook.com/${value}" data-codename="${valueCodeName}">${matchedText}</a>`;
    };

    if (richText.indexOf('fbTag') !== -1) {
      richText = richText.replace(/<span.+class=['"]fbTag['"].*>([^<]+)<\/span>/gmi, replacer);
    }

    if (noShell) {
      pattern = /<body[^>]*>((.|[\n\r])*)<\/body>/im;
      array_matches = pattern.exec(richText);
      if (Array.isArray(array_matches) && array_matches.length > 0) {
        richText = array_matches[1];
      }
    }

    const indexOfSpan = richText.lastIndexOf(linkEndingSpan);

    if (removeWrappingNewLines
                && indexOfSpan !== -1
                && (indexOfSpan >= richText.length - spanLength)) {
      richText = richText.substr(0, indexOfSpan)
                + richText.substr(indexOfSpan).replace(linkEndingSpan, correctedlinkEnding);
    }

    if (removeWrappingNewLines
                && richText.indexOf('\n') === 0
                && richText.lastIndexOf('\n') === richText.length - 1) {
      richText = richText.substr(1, richText.length - 2);
    }

    return richText;
  },

  getPlainTextForSave() {
    let returnText;

    if (!this.messageState.$domBody) {
      return '';
    }
    const inputText = this.getText(this.messageState.$domBody.clone());

    returnText = `${inputText}`;

    if (returnText.indexOf('<') !== -1 && returnText.indexOf('>') !== -1) {
      // -- remove BR tags and replace them with line break
      returnText = returnText.replace(/<br\s*\/?>/gi, '\n');

      // -- remove li tags and replace them with line break
      returnText = returnText.replace(/<\/li>/gi, '\n');

      // -- remove P, h1... and A tags but preserve what's inside of them
      returnText = returnText.replace(/<\/[p|h\d]*>/gi, '\n');
      returnText = returnText.replace(/<p>/gi, '');
      returnText = returnText.replace(/<span.+class=['"]fbTag['"].*>([^<]+)<\/span>/gmi, '$1');

      // -- remove all inside SCRIPT and STYLE tags
      returnText = returnText.replace(/<script.*>[\w\W]{1,}(.*?)[\w\W]{1,}<\/script>/gi, '');
      returnText = returnText.replace(/<style\b[^>]*>([\s\S]*?)<\/style>/gi, '');
    }

    // -- remove all else

    // -- get rid of more than 2 multiple line breaks:
    returnText = returnText.replace(/(?:(?:\r\n|\r|\n)\s*){2,}/gim, '\n\n');

    // -- get rid of more than 2 spaces:
    returnText = returnText.replace(/ +(?= )/g, '');

    if (returnText.indexOf('&') !== -1 && returnText.indexOf(';') !== -1) {
      // -- get rid of html-encoded characters:
      returnText = returnText.replace(/&nbsp;/gi, ' ');
      returnText = returnText.replace(/&amp;/gi, '&');
      returnText = returnText.replace(/&quot;/gi, '"');
      returnText = returnText.replace(/&lt;/gi, '<');
      returnText = returnText.replace(/&gt;/gi, '>');
    }

    returnText = $(`<div>${returnText}</div>`).text();

    if (this.options.selector === 'compose-instagram') {
      returnText = returnText.replace(/(?:\r\n|\r|\n)/g, '\u2800\n');
    }

    return returnText;
  },

  /*
        switchMode: param mode (['rich'|'plain'])
        toggles between plain and rich text editor and enforces a mode
        if user preference is set.
        if site is in concise mode (used by bookmarklet) then always show plain text
     */
  switchMode(mode) {
    if (Utils.$body.hasClass('concise')) {
      this.setEditorModetoPlain();
      return;
    }

    if (mode == 'rich' && this.options.mode == 'rich') {
      mode = 'rich';
    } else if ($current_user.preference == 'rte_on' || $current_user.preference == 'rte_off') {
      mode = $current_user.preference == 'rte_on' ? 'rich' : 'plain';
    }

    if (mode == 'plain' && this.mode == 'rich') {
      this.setEditorModetoPlain();
    } else if (mode == 'rich' && this.mode == 'plain') {
      this.setEditorModetoRich();
    }

    if (mode == 'rich') {
      window.globalObject.composeIsRichMode = true;
    }
  },

  setPlaceholderPosition(mode) {
    if (this.$placeHolder && mode == 'plain') {
      this.$placeHolder.css('top', 0);
    } else if (this.$placeHolder) {
      this.$placeHolder.css('top', 28);
    }
  },

  isRitchModeAllowed() {
    return $current_user.preference !== 'rte_off';
  },

  setEditorModetoPlain() {
    if (!this.tmceEditor) {
      this.tmceEditor = window.tinymce.get(this.options.selector);
      this.container = this.tmceEditor.getContainer();
      this.editor_ifr = this.container.querySelector('iframe');
    }

    this.mode = 'plain';

    window.globalObject.composeIsRichMode = false;

    this.setPlaceholderPosition(this.mode);

    this.tmceEditor.dom.loadCSS(`https://${window.location.hostname}/libs/tinymce/plain.css`);
    this.container.getElementsByClassName('mce-toolbar-grp')[0].style.display = 'none';
    Utils.$body.addClass('editor-in-plainMode');
  },

  setEditorModetoRich() {
    this.mode = 'rich';

    window.globalObject.composeIsRichMode = true;
    // When switching from P to R. It will also remove the plain.css file
    this.tmceEditor.remove();
    this.container = null;
    this.editor_ifr = null;

    // then to re add it run
    tinymce.execCommand('mceAddEditor', false, this.options.selector);

    this.setPlaceholderPosition(this.mode);

    Utils.$body.removeClass('editor-in-plainMode');

    if (this.isMaximised) {
      this.maximizeEditor();
    }
  },

  reloadTinyMCE(callback) {
    // NOTE: CUST-405 Once tinymce is in an error state we need to load it again
    // hence the below code
    window.tinymce = null;
    import('./tinymce-module').then((tinymce) => {
      window.tinymce = tinymce;
      if (callback) {
        callback();
      }
    });
  },

  cleanup() {
    if (this.emojiPicker) {
      this.emojiPicker.cleanup();
    }

    Utils.$body.removeClass('editor-in-plainMode');

    try {
      window.tinymce.EditorManager.execCommand('mceRemoveEditor', true, this.options.selector);
    } catch (error) {
      reportErrorToFaro(error, 'RTEView Cleanup');

      this.reloadTinyMCE();
    }
  },
});

export default RTEView;
